/* eslint-disable */

/**
 * Given an array of properties or an object of property keys,
 * plucks all the values off the target object.
 * @param {{}|string[]} keysToPluck
 * @param {{}} objToPluck
 * @param {Function} transformFn
 * @return {{}}
 */
export default function pluckProps(keysToPluck, objToPluck) {
    const transformFn =
        arguments.length > 2 && arguments[2] !== undefined
            ? arguments[2]
            : x => x;

    return (Array.isArray(keysToPluck)
        ? keysToPluck.slice()
        : Object.keys(keysToPluck)
    ).reduce((memo, prop) => {
        memo[transformFn(prop)] = objToPluck[prop];
        return memo;
    }, {});
}
